/**
 * @copyright 2022 Nuance Communications Inc.
 * All Rights Reserved.
 */

import { Levels } from "@nuance/hierarchical-settings-ui-domain";
import { IFieldDefinitionPanelHeadingData, IFieldDefinitionPanelHeadingState } from ".";
import { getLogger, ILogger } from "@nuance/hux-diagnostics";
import { BaseCommands, FormErrors, IFieldChangeData } from "../../State";
import { CmdBuilder } from "@nuance/hap-components";

const logger: ILogger = getLogger();

export class FieldDefinitionPanelHeadingCommands extends BaseCommands<
    IFieldDefinitionPanelHeadingData,
    IFieldDefinitionPanelHeadingState
> {
    /**
     * Constructor
     */
    constructor() {
        super();
        const cb = new CmdBuilder();
        const cmds = {
            onBlur: cb.bindCmd<IFieldDefinitionPanelHeadingState, string>(this.OnBlurHandler),
            onTextChanged: cb.bindCmd<IFieldDefinitionPanelHeadingState, IFieldChangeData>(
                this.OnTextChangedHandler
            ),
            onAccessLevelChanged: cb.bindCmd<IFieldDefinitionPanelHeadingState, Levels>(
                this.OnAccessLevelChangedHandler
            )
        };

        this.Cmds = cmds;
        this.Reducer = cb.buildReducer<IFieldDefinitionPanelHeadingState>(cmds);
    }

    readonly Cmds;
    readonly Reducer;

    /**
     * Gets the panel data that needs to be save.
     *
     * @param state State containing panel data
     * @returns Data to save
     */
    Save = (state: IFieldDefinitionPanelHeadingState): IFieldDefinitionPanelHeadingData => {
        logger.logInformation("Saving heading properties");

        // important to make a copy!
        return { ...state.data };
    };

    /**
     * Validates the form fields.
     *
     * @param state Current state (immutable)
     * @returns Form errors
     */
    Validate(
        state: IFieldDefinitionPanelHeadingState
    ): FormErrors<IFieldDefinitionPanelHeadingData> {
        const errors: FormErrors<IFieldDefinitionPanelHeadingData> = {};

        if (state.data.headingId === "") {
            errors.headingId = "Heading Id is required.";
        } else {
            if (state.common.validateSettingName === undefined) {
                logger.logError("Heading id validation function not hooked up");
                throw new Error("Unable to validate heading id");
            }

            errors.headingId = state.common.validateSettingName(
                state.data.headingId,
                state.common.originalSettingName
            );
        }

        if (state.data.heading === "") {
            errors.heading = "Heading is required.";
        }

        return errors;
    }
}
